export const originUrl = window.location.origin
export const apiUrl = (window.location.hostname != "localhost") ? window.location.origin : 'https://localhost:7236';
export const baseUrl = (window.location.hostname != "localhost") ? window.location.origin : 'https://localhost:7236';

export const FieldTypes = {
    Text : "text",
    FormName : "formName",
    Email: "email",
    NchLogo: "nchLogo",
    Paragraph: "paragraph",
    Heading: "heading",
    Statement: "statement",
    MouseSignature: "mouseSignature",
    Typeahead: "typeahead",
    NchLogoStacked: "nchLogoStacked",
    Checkbox: "checkbox",
    Container: "container",
    Textarea: "textarea",
    PageBreak: "pagebreak",
    DateMMDDYYYY: "dateMMDDYYYY",
    FormPage: "formPage",
    Dropdown: "dropdown",

}

export const initialState = {
    
  formDivId : '',  
  formLists:'',
  showConfirmation: false,
  formObject :{fields:{}},
  formState:{fields:{}},
  validated: {},
  formLoaded: false,
  saveCopy: false,
  submitFinished: false,
  validationSummaryMessages:{},  
  validated: false,
  apiBusy: false,  
  activePage: '',
  firstPage: '',
  lastPage: '', 
  formObject:''
};

